module.exports = __webpack_public_path__ + "img/borderRectangleWhite.f3a62646.svg";